import { Box, Typography } from '@mui/material'
import { emptyStateSx } from '../styles/NotificationStyle'

export default function EmptyNotifications() {
  return (
    <Box sx={emptyStateSx}>
      <svg
        width="80"
        height="80"
        viewBox="0 0 24 24"
        fill="none"
        style={{
          marginBottom: 16,
          animation: 'shake 1s infinite alternate',
        }}
      >
        <path
          d="M12 22c1.1 0 2-.9 2-2h-4a2 2 0 0 0 2 2zm6-6V11c0-3.07-1.63-5.64-4.5-6.32V4a1.5 1.5 0 0 0-3 0v.68C7.63 5.36 6 7.92 6 11v5l-1.29 1.29A1 1 0 0 0 6 19h12a1 1 0 0 0 .71-1.71L18 16z"
          fill="#aaa"
        />
      </svg>
      <Typography variant="subtitle1">No notifications available</Typography>
      <style>
        {`
          @keyframes shake {
            0% { transform: rotate(-10deg);}
            100% { transform: rotate(10deg);}
          }
        `}
      </style>
    </Box>
  )
}
